import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './EditClientApplicationListLayout.resolver';
import EditClientApplicationListLayout from './EditClientApplicationListLayout';

export default async(resolver, { context: RootStoreContext })(
  EditClientApplicationListLayout
);
